<div class="form-group col-md-{{ colMD }}">
	<label>{{ label }}</label>
	<ng-content></ng-content>
</div>
<div
	*ngIf="hasSeparator()"
	class="kt-separator kt-separator--border-dashed kt-separator--space-lg"
></div>
